import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { Invoices_ShellService } from './Invoices.shell.service';
import { Invoices_OperationService } from './Invoices.operation.service';
import { Invoices_DatasourceService } from './Invoices.datasource.index';
import { Invoices_FlowService } from './Invoices.flow.index';
import { Invoices_ReportService } from './Invoices.report.index';
import { Invoices_LocalizationService } from './Invoices.localization.service';
import { Invoices_invoicing_template_rule_selection_grid_ComponentContextService } from './Invoices.invoicing_template_rule_selection_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './Invoices.frontend.types'
import { $frontendTypes as $types} from './Invoices.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


interface IInvoices_invoicing_template_rule_selection_gridComponentEntity {
  instructionId?: string, billingContractId?: number, projectId?: number, active?: boolean, instructionType?: string, instructionName?: string, billingAggregationStrategyIds?: number[], oneInvoicePerShipment?: boolean, oneInvoicePerWarehouse?: boolean, termId?: number, taxScheduleId?: number, createdOn?: string, createdBy?: string, modifiedOn?: string, modifiedBy?: string, useExistingInvoice?: boolean, priority?: number, isTemplateRule?: boolean, priorityId?: string, billingCodeIds?: number[], schedule?: { date_option?: string, date_interval?: string[], time_option?: string, time_interval?: string, time_offset?: number, time_zone?: { country?: string, utc?: string, time_zone?: string } }, cronExpression?: string, schedule_name?: string}

interface IInvoices_invoicing_template_rule_selection_gridComponentInParams {
  exclude_rule_ids: string[]}

interface IInvoices_invoicing_template_rule_selection_gridComponentOutParams {
  rule_ids?: string[]}

class Invoices_invoicing_template_rule_selection_gridComponentRowModel extends GridRowModel {
  grid: Invoices_invoicing_template_rule_selection_gridComponent;
  entity: IInvoices_invoicing_template_rule_selection_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    active_display: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    use_existing_invoice_display: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
  });

  override cells = {
    name: null,
    active: null,
    type: null,
    term: null,
    tax_schedule: null,
    group_by: null,
    use_existing_invoice: null,
    billing_aggregation_strategies: null,
    billing_codes: null,
    schedule: null,
  }



  constructor(
    grid: Invoices_invoicing_template_rule_selection_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: Invoices_ShellService,
private $datasources: Invoices_DatasourceService,
private $flows: Invoices_FlowService,
private $reports: Invoices_ReportService,
private $localization: Invoices_LocalizationService,
private $operations: Invoices_OperationService,
private $logger: CleanupLoggerService,
private $context: Invoices_invoicing_template_rule_selection_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.active = new GridCellModel(
      new CellStyles(['center'], null),
      this.grid.headers.active,
      new CheckBoxModel(this.formGroup.controls['active_display'] as DatexFormControl, null, false, false, '', null)
,
null
      );
    
    this.cells.type = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.type,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.term = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.term,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.tax_schedule = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.tax_schedule,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.group_by = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.group_by,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.use_existing_invoice = new GridCellModel(
      new CellStyles(['center'], null),
      this.grid.headers.use_existing_invoice,
      new CheckBoxModel(this.formGroup.controls['use_existing_invoice_display'] as DatexFormControl, null, false, false, '', null)
,
null
      );
    
    this.cells.billing_aggregation_strategies = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.billing_aggregation_strategies,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.billing_codes = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.billing_codes,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.schedule = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.schedule,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IInvoices_invoicing_template_rule_selection_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.instructionId].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IInvoices_invoicing_template_rule_selection_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.instructionId].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.instructionId;
    const inParams = {
      $keys:[$resultKey],
      search:  null ,
      billingContractId:  null ,
      projectId:  0 ,
      active:  null ,
      excludeRuleIds:  $grid.inParams.exclude_rule_ids ,
      ruleId:  null ,
    };
    const data = await this.$datasources.Invoices.ds_invoicing_instructions.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IInvoices_invoicing_template_rule_selection_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.name.displayControl as TextModel).text = $row.entity.instructionName;
    (this.cells.active.displayControl as CheckBoxModel).reset($row.entity.active);
    (this.cells.type.displayControl as TextModel).text = $row.entity.instructionType;
    (this.cells.group_by.displayControl as TextModel).text = $row.entity.oneInvoicePerShipment ? 'Shipment' : $row.entity.oneInvoicePerWarehouse ? 'Warehouse' : 'Rule';
    (this.cells.use_existing_invoice.displayControl as CheckBoxModel).reset($row.entity.useExistingInvoice);
    (this.cells.schedule.displayControl as TextModel).text = JSON.stringify($row.entity.schedule);

  }

  override async refresh() {
    if (this.grid.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }


}


@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'Invoices-invoicing_template_rule_selection_grid',
  templateUrl: './Invoices.invoicing_template_rule_selection_grid.component.html'
})
export class Invoices_invoicing_template_rule_selection_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IInvoices_invoicing_template_rule_selection_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);

  fullTextSearch: string;

  inParams: IInvoices_invoicing_template_rule_selection_gridComponentInParams = { exclude_rule_ids: [] };

  outParams: IInvoices_invoicing_template_rule_selection_gridComponentOutParams = { rule_ids: [] };

  //#region Variables
  //#endregion
  //#region Events
  @Output()
  outParamsChange = new EventEmitter<{ rule_ids?: string[] }>();
  
  events = {
    outParamsChange: { emit: () => { this.outParamsChange.emit(this.outParams); } }
  }
  //#endregion

  headers = {
     name: new GridHeaderModel(new HeaderStyles(null, null), 'name', 'Name', false, false, null, false),       active: new GridHeaderModel(new HeaderStyles(['center'], null), 'active', 'Active', false, false, null, false),       type: new GridHeaderModel(new HeaderStyles(null, null), 'type', 'Type', false, false, null, false),       term: new GridHeaderModel(new HeaderStyles(null, null), 'term', 'Invoice term', false, false, null, false),       tax_schedule: new GridHeaderModel(new HeaderStyles(null, null), 'tax_schedule', 'Tax schedule', false, false, null, false),       group_by: new GridHeaderModel(new HeaderStyles(null, null), 'group_by', 'Group billing records by', false, false, null, false),       use_existing_invoice: new GridHeaderModel(new HeaderStyles(['center'], null), 'use_existing_invoice', 'Add billing records to existing invoices', false, false, null, false),       billing_aggregation_strategies: new GridHeaderModel(new HeaderStyles(null, null), 'billing_aggregation_strategies', 'Billing aggregation strategies', false, false, null, false),       billing_codes: new GridHeaderModel(new HeaderStyles(null, null), 'billing_codes', 'Billing codes', false, false, null, false),       schedule: new GridHeaderModel(new HeaderStyles(null, null), 'schedule', 'Schedule', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: Invoices_invoicing_template_rule_selection_gridComponentRowModel[] = [];

  @Input('exclude_rule_ids') set $inParams_exclude_rule_ids(value: any) {
    this.inParams['exclude_rule_ids'] = value;
  }
  get $inParams_exclude_rule_ids(): any {
    return this.inParams['exclude_rule_ids'] ;
  }

  topToolbar = {
      add_rules: new ToolModel(new ButtonModel('add_rules', new ButtonStyles(['primary'], null), false, false, false, 'Add rules', '', null)
    , false),
      cancel: new ToolModel(new ButtonModel('cancel', new ButtonStyles(['secondary'], null), false, false, false, 'Cancel', '', null)
    , false)
  };

  bottomToolbar = {
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: Invoices_ShellService,
    private $datasources: Invoices_DatasourceService,
    private $flows: Invoices_FlowService,
    private $reports: Invoices_ReportService,
    private $localization: Invoices_LocalizationService,
    private $operations: Invoices_OperationService,
    private $logger: CleanupLoggerService,
    private $context: Invoices_invoicing_template_rule_selection_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Template rules';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.exclude_rule_ids)) {
        this.$missingRequiredInParams.push('exclude_rule_ids');
      }
  }

  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 25;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      search:  null ,
      billingContractId:  null ,
      projectId:  0 ,
      active:  null ,
      excludeRuleIds:  $grid.inParams.exclude_rule_ids ,
      ruleId:  null ,
    };
    try {
      const data = await this.$datasources.Invoices.ds_invoicing_instructions.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IInvoices_invoicing_template_rule_selection_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new Invoices_invoicing_template_rule_selection_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_grid_data_loaded();
  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: Invoices_invoicing_template_rule_selection_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    await this.on_row_selected();
  }

  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_grid_data_loaded(event = null) {
    return this.on_grid_data_loadedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_grid_data_loadedInternal(
    $grid: Invoices_invoicing_template_rule_selection_gridComponent,
  
    $shell: Invoices_ShellService,
    $datasources: Invoices_DatasourceService,
    $flows: Invoices_FlowService,
    $reports: Invoices_ReportService,
    $settings: SettingsValuesService,
    $operations: Invoices_OperationService,
    $utils: UtilsService,
    $context: Invoices_invoicing_template_rule_selection_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Invoices_LocalizationService,
    $event: any
  ) {
  const p_terms = $datasources.Invoices.ds_invoice_terms_dd.get({});
  const p_taxes = $datasources.Invoices.ds_tax_schedules_dd.get({});
  const p_billing_aggregation = $datasources.Invoices.ds_billing_aggregation_strategies_dd.get({});
  const p_billing_codes = $datasources.Invoices.ds_billingcodes_dd.get({})
  
  
  const [{ result: terms }, { result: taxes }, { result: billing_aggregation }] = await Promise.all([p_terms, p_taxes, p_billing_aggregation]);
  const [{ result: billing_codes }] = await Promise.all([p_billing_codes]);
  
  
  for (let row of $grid.rows) {
      let bs_ids = row.entity.billingAggregationStrategyIds ?? [];
      let bc_ids = row.entity.billingCodeIds ?? [];
  
  
      if (bs_ids.length > 0) {
  
          let bs_names = billing_aggregation.filter(bs => bs_ids.indexOf(bs.Id) >= 0)?.map(bs => bs.EnumName).join(', ') ?? "";
  
          if (bs_names.length > 50) {
              bs_names = bs_names.slice(0, 47)?.trim()
              bs_names = `${bs_names}...`
          }
          row.cells.billing_aggregation_strategies.displayControl.text = bs_names
      }
  
      if (bc_ids.length > 0) {
          let bc_names = billing_codes.filter(bc => bc_ids.indexOf(bc.Id) >= 0)?.map(bc => bc.Name).join(', ') ?? "";
  
          if (bc_names.length > 50) {
              bc_names = bc_names.slice(0, 47)?.trim()
              bc_names = `${bc_names}...`
          }
  
          row.cells.billing_codes.displayControl.text = bc_names
      }
  
      row.cells.term.displayControl.text = terms.find(t => t.Id === row.entity.termId)?.Name;
      row.cells.tax_schedule.displayControl.text = taxes.find(t => t.Id === row.entity.taxScheduleId)?.Label;
  
      if ($utils.isDefined(row.entity.schedule)) {
          row.cells.schedule.displayControl.text = (await $flows.Invoices.auto_schedule_format_flow({
              schedule: row.entity.schedule
          })).scheduleString;
      }
  }
  
  
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: Invoices_invoicing_template_rule_selection_gridComponent,
  
    $shell: Invoices_ShellService,
    $datasources: Invoices_DatasourceService,
    $flows: Invoices_FlowService,
    $reports: Invoices_ReportService,
    $settings: SettingsValuesService,
    $operations: Invoices_OperationService,
    $utils: UtilsService,
    $context: Invoices_invoicing_template_rule_selection_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Invoices_LocalizationService,
    $event: any
  ) {
  $grid.outParams.rule_ids = [];
  }
  on_row_selected(event = null) {
    return this.on_row_selectedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_selectedInternal(
    $grid: Invoices_invoicing_template_rule_selection_gridComponent,
  
    $shell: Invoices_ShellService,
    $datasources: Invoices_DatasourceService,
    $flows: Invoices_FlowService,
    $reports: Invoices_ReportService,
    $settings: SettingsValuesService,
    $operations: Invoices_OperationService,
    $utils: UtilsService,
    $context: Invoices_invoicing_template_rule_selection_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Invoices_LocalizationService,
    $event: any
  ) {
  $grid.topToolbar.add_rules.control.readOnly = $grid.selectedRows.length === 0;
  }
  on_confirm_clicked(event = null) {
    return this.on_confirm_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_confirm_clickedInternal(
    $grid: Invoices_invoicing_template_rule_selection_gridComponent,
  
    $shell: Invoices_ShellService,
    $datasources: Invoices_DatasourceService,
    $flows: Invoices_FlowService,
    $reports: Invoices_ReportService,
    $settings: SettingsValuesService,
    $operations: Invoices_OperationService,
    $utils: UtilsService,
    $context: Invoices_invoicing_template_rule_selection_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Invoices_LocalizationService,
    $event: any
  ) {
  $grid.outParams.rule_ids = $grid.selectedRows.map(row => row.entity.instructionId);
  $grid.close();
  }
  on_cancel_clicked(event = null) {
    return this.on_cancel_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_cancel_clickedInternal(
    $grid: Invoices_invoicing_template_rule_selection_gridComponent,
  
    $shell: Invoices_ShellService,
    $datasources: Invoices_DatasourceService,
    $flows: Invoices_FlowService,
    $reports: Invoices_ReportService,
    $settings: SettingsValuesService,
    $operations: Invoices_OperationService,
    $utils: UtilsService,
    $context: Invoices_invoicing_template_rule_selection_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Invoices_LocalizationService,
    $event: any
  ) {
  $grid.close();
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
